import React, { useCallback } from 'react';
import { first, result } from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Label, Stack } from '@fluentui/react';
import { HelpPopupInline } from '@bingads-webui-react/help-popup';
import { withCustomValidation, withError } from '@bingads-webui-react/validation';
import { UrlInputFluent } from '@bingads-webui-campaign-react/url-input-fluent';

const MobileUrlKey = 'MobileFinalUrls';
const valuePrefix = ['http://', 'https://'];

const MobileUrlWithCustomValidation = ({
  validationProps,
  updateValidation,
  i18n,
  helpTopicId,
  validateOnRender,
  customizedValidation,
  isControlledOutside,
  validateOnDomain,
}) => {
  const { data } = validationProps;

  const mobileFinalUrls = result(data, MobileUrlKey, [undefined]);
  const mobileFinalUrl = first(mobileFinalUrls);

  const onInputChange = useCallback((errors, value) => {
    const formattedValue = valuePrefix.includes(value) && validateOnDomain ? '' : value;
    const updatedErrors = valuePrefix.includes(value) && validateOnDomain ? [] : errors;
    if (mobileFinalUrl !== formattedValue || isControlledOutside) {
      updateValidation(updatedErrors, { [MobileUrlKey]: [formattedValue] });
    }
  }, [isControlledOutside, mobileFinalUrl, updateValidation, validateOnDomain]);

  return (
    <div className={classNames('mobile-url-container')}>
      <React.Fragment>
        <Label className="mobile-final-url-label">
          <Stack horizontal verticalAlign="center" >
            {i18n.getString(_TL_('Mobile URL'))}
            <HelpPopupInline topic={helpTopicId} />
          </Stack>
        </Label>
        <UrlInputFluent
          containerClassName="mobile-final-url"
          url={mobileFinalUrl}
          onChange={onInputChange}
          i18n={i18n}
          dropdownOptionAriaLabel={i18n.getString(_TL_('Mobile URL'))}
          textFieldAriaLabel={i18n.getString(_TL_('Mobile URL'))}
          validateOnRender={validateOnRender}
          customizedValidation={customizedValidation}
        />
      </React.Fragment>
    </div>
  );
};

MobileUrlWithCustomValidation.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      MobileFinalUrls: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
  helpTopicId: PropTypes.string,
  validateOnRender: PropTypes.bool,
  customizedValidation: PropTypes.func,
  isControlledOutside: PropTypes.bool,
  validateOnDomain: PropTypes.bool,
};

MobileUrlWithCustomValidation.defaultProps = {
  helpTopicId: 'pop_BA_NewCampaignCreate_Ad_MobileURL',
  validateOnRender: false,
  validateOnDomain: false,
  customizedValidation: null,
  isControlledOutside: false,
};

export const ValidatedMobileUrlWithoutCheckbox = withError(withCustomValidation(MobileUrlWithCustomValidation));
